import { testimonialService } from "../../services/testimonials";
import { frontEndConstants } from "../constant/front-end-constant";
import { alertActions } from "./alert-actions";

export function getTestimonials(brand_id, page, pageSize, sort, filter, is_admin) {
    return dispatch => {
        dispatch(request());
         testimonialService.getTestimonials(brand_id, page, pageSize, sort, filter, is_admin).then(
            response => {
                dispatch(success(response));
                // return response
            },
            error => {
                dispatch(failure(error))
            }
        )
    }
    function request() { return { type: frontEndConstants.GET_ALL_TESTIMONIALS_REQUEST } }
    function success(response) { return { type: frontEndConstants.GET_ALL_TESTIMONIALS_SUCCESS, payload: response } }
    function failure(error) { return { type: frontEndConstants.GET_ALL_TESTIMONIALS_FAILURE, payload: error } }
}

export function storeTestimonial(data) {
    return dispatch => {
        return testimonialService.storeTestimonial(data).then(
            response => {
                dispatch(alertActions.success(response.message));
                return response
            },
            error => {
                dispatch(failure(error))
                return Promise.reject(error)
            }
        )
    }
    // function success(response) { return { type: frontEndConstants.STORE_TESTIMONAIL_SUCCESS, payload: response } }
    function failure(error) { return { type: frontEndConstants.STORE_TESTIMONAIL_FAILURE, payload: error } }
}

export function deleteTestimonial(id) {
    return dispatch => {
        testimonialService.deleteTestimonial(id).then(
            response => {
                dispatch(alertActions.success(response.message));
            },
            error => {
                dispatch(alertActions.error(error));
            }
        )
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/testimonials.jsx